import { GraphQLClient } from 'graphql-request';
import { getApiUrl } from '../../config';




export const request = async <T>(
  query: string,
  variables?: any,
  language = 'en',
  token = localStorage.getItem('token'),
): Promise<T> => {
  const endpoint = `${getApiUrl()}/${language}/graphql`;
  const gqlClient = new GraphQLClient(endpoint);
  gqlClient.setHeader('Authorization', token ? `Bearer ${token}` : '');
  return gqlClient.request<T>(query, variables);
};
